//#region frontend/entrypoints/sf-swiper.js
var SwiperSlider = class {
	constructor(element) {
		this.element = element;
		this.selectors = {
			sliderWrapper: ".swiper-wrapper",
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
			paginationEl: ".swiper-pagination"
		};
		this.classes = {
			grid: "f-grid",
			swiper: "swiper",
			swiperWrapper: "swiper-wrapper"
		};
		this.sectionId = this.element.dataset.sectionId;
		this.section = this.element.closest(`.section-${this.sectionId}`);
		this.sliderWrapper = this.element.querySelector(this.selectors.sliderWrapper);
		this.sliderInstance = false;
		this.init();
	}
	init() {
		this.initSlider();
	}
	initSlider() {
		const sliderOptions = {
			modules: [
				FoxTheme.Swiper.Navigation,
				FoxTheme.Swiper.Pagination,
				FoxTheme.Swiper.Mousewheel
			],
			slidesPerView: "auto",
			spaceBetween: 12,
			navigation: {
				nextEl: this.element.querySelector(this.selectors.nextEl),
				prevEl: this.element.querySelector(this.selectors.prevEl)
			},
			pagination: {
				el: this.element.querySelector(this.selectors.paginationEl),
				clickable: true
			},
			loop: false,
			threshold: 2,
			mousewheel: {
				enabled: true,
				forceToAxis: true
			},
			breakpoints: {
				768: {
					spaceBetween: 20,
					slidesPerView: "auto"
				},
				1024: {
					spaceBetween: 20,
					slidesPerView: "auto"
				},
				1280: {
					spaceBetween: 20,
					slidesPerView: "auto"
				}
			}
		};
		const pointOptions = {
			modules: [
				FoxTheme.Swiper.Navigation,
				FoxTheme.Swiper.Pagination,
				FoxTheme.Swiper.Mousewheel,
				FoxTheme.Swiper.Autoplay
			],
			slidesPerView: "auto",
			centeredSlides: true,
			loop: false,
			mousewheel: {
				enabled: true,
				forceToAxis: true
			},
			autoplay: {
				delay: 3e3,
				disableOnInteraction: false,
				waitForTransition: false
			},
			breakpoints: { 641: { centeredSlides: false } }
		};
		if (typeof this.sliderInstance !== "object") {
			if (this.element.classList.contains("p-index-point__slider")) this.sliderInstance = new window.FoxTheme.Carousel(this.element, pointOptions);
			else this.sliderInstance = new window.FoxTheme.Carousel(this.element, sliderOptions);
			this.sliderInstance.init();
		}
	}
};
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".swiper-container").forEach((element) => {
		new SwiperSlider(element);
	});
});
//#endregion
